const MobileProtectIcon = ({ width = "16px", height = "16px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={width}
    height={height}
  >
    <path
      fill="#000"
      d="M11 11 8.5 8.52l.8-.78L11 9.43l3.7-3.68.8.79L11 11Zm1-10H3a1 1 0 0 0-1 1v7.15a5.52 5.52 0 0 0 2.75 4.75l2.75 1.6 2.7-1.6c.46-.26.87-.6 1.23-.97l-.68-.68c-.3.3-.63.57-1 .8L7.5 14.4l-2.25-1.35A4.5 4.5 0 0 1 3 9.15V2h9v2.5h1V2a1 1 0 0 0-1-1Z"
    />
  </svg>
);

export default MobileProtectIcon;
